import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import { PngIcon } from "../../common/PngIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
  disabled?: boolean;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src, disabled = true} : SocialLinkProps) => {
    const commonStyles: React.CSSProperties = {
      opacity: disabled ? 0.5 : 1,
      pointerEvents: disabled ? "none" : "auto",
      cursor: disabled ? "not-allowed" : "pointer",
    };
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={commonStyles}
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      {false &&
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              {
                false && 
                <>
                  <Language>{t("Contact")}</Language>
                  <Large to="/">{t("Tell us everything")}</Large>
                  <Para>
                    {t(`Do you have any question? Feel free to reach out.`)}
                  </Para>
                  <a href="mailto:c.programptyltd@gmail.com">
                    <Chat>{t(`Let's Chat`)}</Chat>
                  </a>
                </>
              }
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              {
                false && 
                <>
                  <Title>{t("Policy")}</Title>
                  <Large to="/">{t("Application Security")}</Large>
                  <Large to="/">{t("Software Principles")}</Large>
                </>
              }
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              {
                false && 
                <>
                  <Empty />
                  <Large to="/">{t("Support Center")}</Large>
                  <Large to="/">{t("Customer Support")}</Large>
                </>
              }
            </Col>
          </Row>
          {
            !false &&
            <Row justify="space-between">
              <Col lg={10} md={10} sm={12} xs={12}>
                <Language>{t("Address")}</Language>
                <Para>Suite 14, Ground Floor</Para>
                <Para>135-153 New South Head Road</Para>
                <Para>Edgecliff NSW 2027</Para>
                <Para>AUSTRALIA</Para>
              </Col>
              <Col lg={8} md={8} sm={12} xs={12}>
                <Title>{t("Company")}</Title>
                <Large to="/">{t("About")}</Large>
                <Large to="/">{t("Blog")}</Large>
                <Large to="/">{t("Press")}</Large>
                <Large to="/">{t("Careers & Culture")}</Large>
              </Col>
              <Col lg={6} md={6} sm={12} xs={12}>
                <Label htmlFor="select-lang">{t("Language")}</Label>
                <LanguageSwitchContainer>
                  <LanguageSwitch onClick={() => handleChange("en")}>
                    <SvgIcon
                      src="united-states.svg"
                      aria-label="homepage"
                      width="30px"
                      height="30px"
                    />
                  </LanguageSwitch>
                  
                  {
                    false &&
                    <LanguageSwitch onClick={() => handleChange("es")}>
                      <SvgIcon
                        src="spain.svg"
                        aria-label="homepage"
                        width="30px"
                        height="30px"
                      />
                    </LanguageSwitch>
                  }
                </LanguageSwitchContainer>
              </Col>
            </Row>
          }
        </Container>
      </FooterSection>
      }
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <PngIcon
                  src="logo.png"
                  aria-label="homepage"
                  width="auto"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="https://github.com"
                src="github.svg"
              />
              <SocialLink
                href="https://twitter.com"
                src="twitter.svg"
              />
              <SocialLink
                href="https://www.linkedin.com"
                src="linkedin.svg"
              />
              <SocialLink
                href="https://medium.com"
                src="medium.svg"
              />
              <a
                href="https://ko-fi.com/cprogram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="36"
                  style={{ border: 0, height: 36 }}
                  src="https://storage.ko-fi.com/cdn/kofi3.png?v=3"
                  alt="Buy Me a Coffee at ko-fi.com"
                />
              </a>
            </FooterContainer>
          </Row>
          <Row>
            <Para>C. Program Pty Ltd</Para>
            <Para>Suite 14, Ground Floor, 135-153 New South Head Road</Para>
            <Para>Edgecliff NSW 2027</Para>
            <Para>AUSTRALIA</Para>
            <Para>{" "}</Para>
            <Para>ABN: 79 668 678 788</Para>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
